import Phaser from 'phaser';
import { VIEWPORT_H, VIEWPORT_W } from './constants';

export function phaserInternalSize() {
  return {
    width: VIEWPORT_W,
    height: VIEWPORT_H,
    scale: 1,
  };
}

export function applySceneRenderBudget(scene: Phaser.Scene) {
  scene.cameras.main?.setZoom(1);
}
